import React, { useCallback, useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";

import { Footer } from "../../components/Footer/Footer";

function PositivityCategoryDesktop({ app, config }) {
  const infoCards = useMemo(
    () => [
      {
        title: "Extrato de tomate",
        reakized: "DrJPzhV",
        ating: "depDzmB",
        bestDistribuidor: "pFpR",
      },
      {
        title: "Molho de tomate",
        reakized: "KmCTpSF",
        ating: "jbFJmj",
        bestDistribuidor: "DPMcm",
      },
      {
        title: "Molho de Tomate Chef",
        reakized: "eRdj",
        ating: "JZCEjvZ",
        bestDistribuidor: "nmVkLhB",
      },
      {
        title: "Azeites",
        reakized: "KWPHCrU",
        ating: "emrp",
        bestDistribuidor: "RjZdVB",
      },
      {
        title: "OESP Liza /Purilev",
        reakized: "vJcsV",
        ating: "XwvJjZ",
        bestDistribuidor: "pnpujdm",
      },
      {
        title: "Maionese",
        reakized: "CsARyx",
        ating: "nVcVpR",
        bestDistribuidor: "arUGkn",
      },
      {
        title: "Óleos Compostos",
        reakized: "QfLpgm",
        ating: "JwHpXw",
        bestDistribuidor: "zyzNXj",
      },
      {
        title: "Molhos para Salada",
        reakized: "YKagQCP",
        ating: "zmde",
        bestDistribuidor: "wHSNBP",
      },
      {
        title: "Condimentos",
        reakized: "cjQKD",
        ating: "LAnLV",
        bestDistribuidor: "JgXsLc",
      },
      {
        title: "Óleos Nobres",
        reakized: "TbCPBx",
        ating: "geJVcVE",
        bestDistribuidor: "YfaBxvN",
      },
    ],
    []
  );
  const [kpiValues, setKpiValues] = useState([]);

  const fetchKPIValueShowKpis = useCallback(async () => {
    if (app) {
      const fetchKPIValue = async (id) => {
        try {
          const res = await app.visualization.get(id);
          const value = res?.model?.layout?.style?.label;
          return value;
        } catch (error) {
          console.error("Erro ao buscar valor para", id, error);
          return null;
        }
      };

      const updatedKpiValues = await Promise.all(
        infoCards.map(async (item) => {
          const reakizedValue = await fetchKPIValue(item.reakized);
          const atingValue = await fetchKPIValue(item.ating);
          const bestDistribuidorValue = await fetchKPIValue(
            item.bestDistribuidor
          );

          return {
            title: item.title,
            reakized: reakizedValue,
            ating: atingValue,
            bestDistribuidor: bestDistribuidorValue,
          };
        })
      );

      setKpiValues(updatedKpiValues);
    }
  }, [app, infoCards]);

  useEffect(() => {
    fetchKPIValueShowKpis();
  }, []);

  return (
    <div className="app positivityCategory">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container className="container-cars-kpis">
            {kpiValues?.map((item, index) => (
              <Card
                key={index}
                header={{
                  hardTitle: `${item.title}`,
                }}
              >
                <div className="bory-card">
                  <p>
                    <span className="value"> {item.reakized} </span>
                    <span className="text"> Realizado </span>
                  </p>
                  <p>
                    <span className="value">{item.ating}</span>
                    <span className="text">Atingimento</span>
                  </p>
                </div>

                <div className="footer-card">
                  <p>
                    <span>Melhor distribuidor: </span>
                    <span>{item.bestDistribuidor}</span>
                  </p>
                </div>
              </Card>
            ))}
          </Grid>

          <Grid className="container-desempenho">
            <Card
              app={app}
              header={{
                hardTitle: "Desempenho",
              }}
              exportContainer
              exportTable
              exportTableId="ZZpsX"
              style={{ margin: "16px 0" }}
            >
              <NativeObject
                app={app}
                key="ZZpsX"
                reference={{ id: "ZZpsX" }}
                style={{
                  width: "100%",
                  height: "300px",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

PositivityCategoryDesktop.defaultProps = {
  app: null,
  config: {},
};

PositivityCategoryDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivityCategoryDesktop;
